/**
 * orga-app-api - api-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReadModelUpdatedNotification { 
    entity_id: string;
    entity_type: string;
    entity_part: string;
    entity: string;
    method: string;
    reason?: string;
    tags?: Array<string>;
    notification_type?: string;
}

